import { ErrorHandler, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import SkinJson from '../../../assets/sample/skin.json';



export interface Skin {
  /**
   * CSS that should be included in the document <head>. Note this includes the <style> tags.
   */
  css: string;

  /**
   * Inline SVGs that should be included after the opening <body> tag.
   */
  svg: string;

  /**
   * Script tags that should be included before the closing <body> tag. Note this includes the <script> tags
   * themselves. The script should not be added to the document until after the HTML for the header and footer
   * has been loaded.
   */
  js: string;

  /**
   * Header HTML
   */
  header: string;

  /**
   * Footer HTML
   */
  footer: string;
}


@Injectable()
export class SkinService {
  constructor(private http: HttpClient, private _errorHandler: ErrorHandler) {}

  public async load(): Promise<void> {
    try {
      setTimeout(function() {
        // @ts-ignore
        const $head = $('head');
        // @ts-ignore
        const $body = $('body');
        // @ts-ignore
        const $headerContainer = $('.app__header-container');
        // @ts-ignore
        const $footerContainer = $('.app__footer-container');

        // Fetch the skin components - this is from the old webservice on Coldfusion
        // const skin = await this.http.get<Skin>(environment.skinServiceUrl, { withCredentials: true }).toPromise();

        // the skin is now in a JSON file in the local assets folder
        const skin = SkinJson;

        // Add the skins components to the page
        $head.append(skin.css);
        $body.prepend(skin.svg);
        $headerContainer.prepend(skin.header);
        skin.footer = skin.footer.replace('DatePlaceholder', new Date().getFullYear());
        $footerContainer.append(skin.footer);
        $body.append(skin.js);

        // Initialize the header
        Aopa.header.init({
          mini: true,
          sticky: false
        });
      }, 4000);
    } catch (e) {
      this._errorHandler.handleError(e);
    }
  }
}
